'use client'

import {useEffect, useRef, useState} from 'react'
import Button from './common/Button'

type Props = {
  videoSrc: string
  buttonLabel?: string
}

export default function DemoVideoModal({videoSrc}: Props) {
  const [open, setOpen] = useState(false)
  const videoRef = useRef<HTMLVideoElement | null>(null)

  // Stop video on close
  useEffect(() => {
    if (!open && videoRef.current) {
      videoRef.current.pause()
      videoRef.current.currentTime = 0
    }
  }, [open])

  // ESC key to close
  useEffect(() => {
    if (!open) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open])

  return (
    <>
      {/* Trigger Button */}
      <Button variant="tertiary" onClick={() => setOpen(true)}>
        Watch Demo
      </Button>

      {/* Modal */}
      {open && (
        <div style={styles.backdrop} onClick={() => setOpen(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <button onClick={() => setOpen(false)} style={styles.close} aria-label="Close video">
              ✕
            </button>

            <video ref={videoRef} src={videoSrc} controls autoPlay style={styles.video} />
          </div>
        </div>
      )}
    </>
  )
}

const styles: Record<string, React.CSSProperties> = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modal: {
    position: 'relative',
    width: '90%',
    maxWidth: 900,
    background: '#000',
    borderRadius: 12,
    padding: 8,
  },
  video: {
    width: '100%',
    height: 'auto',
    borderRadius: 8,
  },
  close: {
    position: 'absolute',
    top: -12,
    right: -12,
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    fontSize: 18,
    background: '#fff',
  },
}
